import React, { useState } from "react";
import MusicHero from "../components/music/MusicHero";
import GenreFilter from "../components/music/GenreFilter";
import NewReleases from "../components/music/NewReleases";
import AllMusicGrid from "../components/music/AllMusicGrid";
import ShareSoundCta from "../components/music/ShareSoundCta";

export default function Music() {
  const [query, setQuery] = useState("");
  const [submittedQuery, setSubmittedQuery] = useState("");
  const [activeGenre, setActiveGenre] = useState("All");

  return (
    <>
      <MusicHero query={query} onQueryChange={setQuery} onSearch={setSubmittedQuery} />
      <GenreFilter activeGenre={activeGenre} onSelectGenre={setActiveGenre} />
      <NewReleases />
      <AllMusicGrid searchQuery={submittedQuery} activeGenre={activeGenre} />
      <ShareSoundCta />
    </>
  );
}
